import { Box, Typography } from '@material-ui/core'
import { SwitchIOS } from 'components/SwitchIOS'

import { useStyles } from './styles'

interface IViewToggleProps {
  viewMode: 'orders' | 'items'
  onToggle: () => void
}

export const ViewToggle = ({ viewMode, onToggle }: IViewToggleProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Typography 
        className={`${classes.label} ${viewMode === 'orders' ? classes.activeLabel : ''}`}
      >
        Pedidos
      </Typography>
      <SwitchIOS checked={viewMode === 'items'} onChange={onToggle} />
      <Typography 
        className={`${classes.label} ${viewMode === 'items' ? classes.activeLabel : ''}`}
      >
        Itens
      </Typography>
    </Box>
  )
}

